module.exports = __webpack_public_path__ + "media/images/activity-indicator-light-7e7e6608f91f0b836d22dd3885b6d9a4.svg";